import { render, staticRenderFns } from "./AppointmentSlotManagement.vue?vue&type=template&id=28a7438c&scoped=true"
import script from "./AppointmentSlotManagement.vue?vue&type=script&lang=js"
export * from "./AppointmentSlotManagement.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSlotManagement.vue?vue&type=style&index=0&id=28a7438c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b4d2f5f63767a7c4cbcbe44ae7bf34d4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a7438c",
  null
  
)

export default component.exports